import { render, staticRenderFns } from "./EmmaChat.vue?vue&type=template&id=6cb19812&"
import script from "./EmmaChat.vue?vue&type=script&lang=ts&"
export * from "./EmmaChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports